import React from 'react';
import constants from '../../constants';
import ApplyFiltersImg from '../../assets/images/ApplyFilters.jpg';
 

const ApplyFilters = ({type = 0, text = "Choose a Date from the filters above and hit Apply to load the Attendance Report."  }) => {
  return (
    <div className='applyFiltersContainer'>
        <img 
          src={ApplyFiltersImg}
          alt="Apply Filters" 
          className='applyFiltersimg' 
        />
        <p className={`applyFiltersText ${type === 1 ? "applyFiltersText1" : ""}`}>{text}</p>
    </div>
  )
}

export default ApplyFilters;
